import React from 'react';
import routes from '../../config/routes';
import { useHistory } from 'react-router-dom';
import Constants from '../../Utility/Constants';

export default function BreadCrumbs({ categoryName, productsTitle, subCategoryTitle, isMobile }) {
    const history = useHistory();
    return <nav className={`${isMobile ? 'pt-3 text-capitalize' : 'd-none d-md-block text-capitalize'}`} aria-label="breadcrumb">
        <ol className={`${isMobile ? 'breadcrumb' : 'breadcrumb white'}`}>
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            {<li className="breadcrumb-item ">
                <a href={categoryName === 'Grocery' ? routes.CATEGORY_LIST : '/category/bistro'} className='title-case'>{categoryName?.toLowerCase() === Constants.PRODUCT_GROUP.GROCERY.toLowerCase() ? Constants.Product_Name.GROCERY : categoryName?.toLowerCase()}</a>
            </li>}
            {productsTitle ? <li className={`breadcrumb-item ${!subCategoryTitle ? 'active' : ''}`}>
                {subCategoryTitle ? <a
                    id='subCategory'
                    style={{ cursor: 'pointer' }}
                    onClick={() => subCategoryTitle && history.goBack()}
                    className='title-case'
                >{productsTitle?.toLowerCase()}</a> : productsTitle?.toLowerCase()}
            </li> : null}
            {subCategoryTitle ? <li className={`title-case breadcrumb-item ${subCategoryTitle ? 'active' : ''}`} aria-current="page">{subCategoryTitle?.toLowerCase()}</li> : null}
        </ol>
    </nav>
}